import { type FC, type ReactNode } from "react";
import classNames from "classnames";

interface Props {
  className?: string;
  children?: ReactNode;
}

const CheckoutSectionTitle: FC<Props> = ({ children, className }) => (
  <h2 className={classNames(className, "headline-small")}>{children}</h2>
);

export default CheckoutSectionTitle;
